import { StorageConstants } from "../constants/Constants";
import CryptoJS from "crypto-js";

/** Router basename + redirect prefix; derived from build-time PUBLIC_URL (CRA). */
const getAppBasePath = (): string => {
  const raw = (process.env.PUBLIC_URL || "").trim();
  if (!raw || raw === "/" || raw === ".") return "";
  try {
    const origin =
      typeof window !== "undefined"
        ? window.location.origin
        : "http://localhost";
    const pathname = new URL(raw, `${origin}/`).pathname;
    return pathname.replace(/\/$/, "") || "";
  } catch {
    const normalized = raw.replace(/\/$/, "");
    if (!normalized || normalized === "/") return "";
    return normalized.startsWith("/") ? normalized : `/${normalized}`;
  }
};

const appBasePath = getAppBasePath();

const ENCODE_SECRET_KEY_1 =
  "#&*BB&G*&#&*#G8754454^&*T*&GMAN&^#$$ISH883782&**78";
const ENCODE_SECRET_KEY_2 =
  "!@#$%^&*()UJCFFGS4548MAN/*+5+5as8as7d6t7ISH&^*^&^*";

const isJson = (str: any) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

const decodeData = (value: any): any => {
  try {
    if (value == null || value === undefined || value === "undefined")
      return value;
    if (typeof value !== "string") return value;
    const replaceddata = value.replaceAll("Enc@de", "/");
    const decryptedData = CryptoJS.AES.decrypt(
      replaceddata,
      ENCODE_SECRET_KEY_2,
    ).toString(CryptoJS.enc.Utf8);
    const decryptedData1 = CryptoJS.AES.decrypt(
      decryptedData,
      ENCODE_SECRET_KEY_1,
    ).toString(CryptoJS.enc.Utf8);
    return decryptedData1 || value;
  } catch {
    return value;
  }
};

const getFromStorage = ({
  key,
  type = "local",
  isSecure = true,
}: {
  key: string;
  type?: string;
  isSecure?: boolean;
}): any => {
  try {
    let value: any = null;
    if (type === "local") value = localStorage.getItem(key);
    else if (type === "session") value = sessionStorage.getItem(key);
    if (isSecure) value = decodeData(value);
    return isJson(value) ? JSON.parse(value) : value;
  } catch {
    return null;
  }
};

export const Config: any = {
  url: "",
  DATE_TIME_FORMATE: "YYYY-MM-DD[T]HH:mm:ss",

  /** Set REACT_APP_API_BASE_URL in .env.* or CI; fallback keeps current demo API. */
  REACT_APP_API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL ||
    "https://demo.dev9server.com:3057/api/web",
  IS_USER_LOGIN_TOKEN: getFromStorage({
    key: StorageConstants?.IS_USER_LOGIN_TOKEN,
  }),
  ENCODE_SECRET_KEY_1: "#&*BB&G*&#&*#G8754454^&*T*&GMAN&^#$$ISH883782&**78",
  ENCODE_SECRET_KEY_2: "!@#$%^&*()UJCFFGS4548MAN/*+5+5as8as7d6t7ISH&^*^&^*",
  FACEBOOK_SOCIAL_LOGIN_APP_ID: "641088710888267",
  FACEBOOK_SOCIAL_LOGIN_APP_SECRET: "3511c97b5116ce2cb5eac92b2d869421",
  USER_DETAILS: getFromStorage({ key: StorageConstants?.USER_DETAIL }),
  /** Same as React Router basename; from PUBLIC_URL in .env / CI (see getAppBasePath). */
  BASE_URL: appBasePath,
  GOOGLE_MAP_API_KEY:
    "U2FsdGVkX19jeAykEWTCMH125zFJgMkdhwRbGsbVUXNgb6mLKZxFabB+5sMEoZXiwNlCklh9TPaiJMxgFwd7qUwJqDiB49veA43TTByKZPaid5Tj2vr33np9h7PaiU4EBOD5sSvwusVD3oIvgYElVph4DF6w==",
  // GOOGLE_MAP_API_KEY: "U2FsdGVkX1+GYMANMn5jwBMbRK3kEmGEnHzEZIB5RMwqNlLmIi1kfXnAIEQSasBAyqEnc@denhennSHGXIuGym4TIfUnXU5OSlnob8DYdfeVLpllKh7OEr6ynZSadOHA056wj3oYCmtybWnlaQtjiYgXyCA=="
};
